/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./describeRepo.defs.js";
export { main as default } from "./describeRepo.defs.js";
